import { Title, TitleSection, Wrapper } from "../Properties/Details/styles";
import TradeRegistrationTypes from "./TradeRegistrationTypes";
import TradesCategories from "./TradesCategory";

export default function TradeResource() {
  return (
    <Wrapper>
      <TitleSection>
        <Title>Trade Resource Management </Title>
      </TitleSection>
      <TradesCategories />
      <TradeRegistrationTypes />
    </Wrapper>
  );
}
